import { EPIC_VALUE_CAROUSEL_CONTAINERS, HOMEPAGE_KEY } from '../epicValueCarousel/createEpicValueContainer';

const GAMING_WIDGET_CONTAINER = 'gaming-widget-container';

export const createRootContainer = () => {
    const hiddenMarketsContainer = document.getElementById('hidden-markets-container');
    const epicValueCarouselContainer = document.getElementById(EPIC_VALUE_CAROUSEL_CONTAINERS[HOMEPAGE_KEY]);

    const rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', GAMING_WIDGET_CONTAINER);

    if(!epicValueCarouselContainer && !hiddenMarketsContainer) {
        return null;
    }

    if(epicValueCarouselContainer) {
        epicValueCarouselContainer.after(rootContainer);
    }

    if(hiddenMarketsContainer && !epicValueCarouselContainer) {
        hiddenMarketsContainer.after(rootContainer);
    }

    return rootContainer;
};
